
import { defineComponent } from 'vue';

import EntryIndex from '@/components/Frontend/EntryIndex.vue';
export default defineComponent({
  components: {
    EntryIndex,
  },
});
